declare var swal: any;
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { SpinnerService } from '../../../../services/spinner.service';
import { FDService } from '../../../../services/fd.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FDActorDocRequest, FdActorDocReportDetailsController, FDActorReportDetailsDocRequest } from '../../../../models/formdesign/fd.model';
import { AppData } from '../../../../models/appdata';
import { ApiResponseModel } from '../../../../models/api_response_model';
import { DBOperation } from '../../../../enums/enum';

import * as alertFunctions from '../../../../../shared/data/sweet-alerts';


@Component({
  selector: 'actorformdetails',
  templateUrl: './actorformdetails.component.html',
  styleUrls: ['./actorformdetails.component.scss']
})

export class ActorFormDetailsComponent implements OnInit {

  CurrentFDActorDocRequest: FDActorDocRequest;
  public ApiResData: ApiResponseModel;
  public isRequesting: boolean = false;
  public ActorReportCode: number = 0;
  public ActorCode: number = 0;

  CurrentFDActorReportDetailsDocRequest: FDActorReportDetailsDocRequest;

  CurrentFdActorDocReportDetailsController: FdActorDocReportDetailsController[];

  constructor(private router: Router,
    private route: ActivatedRoute, private loaderService: SpinnerService, private fdservice: FDService,
    private modalService: NgbModal) { }


  ngOnInit() {
    this.ActorCode = AppData.Instance().UserLoginDetails.ActorCode;

    this.CurrentFDActorDocRequest = new FDActorDocRequest();
    this.CurrentFDActorDocRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.CurrentFDActorDocRequest.ActorCode = AppData.Instance().UserLoginDetails.ActorCode;
    this.CurrentFDActorDocRequest.CreatedUserName = AppData.Instance().UserLoginDetails.UserName;

    this.CurrentFdActorDocReportDetailsController = new Array<FdActorDocReportDetailsController>();


    this.CurrentFDActorReportDetailsDocRequest = new FDActorReportDetailsDocRequest();
    this.CurrentFDActorReportDetailsDocRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;

    this.CurrentFDActorReportDetailsDocRequest.FdActorDocReportDetailsController = new Array<FdActorDocReportDetailsController>();

    //this.GetFdActorDocReportDetailsController();



  }
  public onSubmitActorReport() {
    if (this.ActorReportCode > 0) {
      this.CurrentFDActorDocRequest.ActorReportCode = this.ActorReportCode;
      this.GetFdActorDocReportDetailsController();
    }
    else {
      alertFunctions.AlertParam('Please Select Template Properly...!');
    }
  }
  GetFdActorDocReportDetailsController() {
    this.StartRefreshing();
    this.fdservice.GetFdActorDocReportDetailsController(this.CurrentFDActorDocRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentFdActorDocReportDetailsController = this.ApiResData.Result;

        //  console.log('CurrentFdActorDocReportDetailsController--->' + this.CurrentFdActorDocReportDetailsController[0].CanShowTitle);

         
          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


      (error) => {

        if (error == "401 - Unauthorized") {
          alertFunctions.AlertParamEr(error);
          this.stopRefreshing();



        }
        else {
          alertFunctions.AlertParamEr(error);
          this.stopRefreshing();
        }
      }


      );

  }

  public setradioAnswer(FDRIAnswer: any, index: number) {
    //console.log('FDRIAnswer--->' + FDRIAnswer)
    //console.log('index--->' + index)
    this.CurrentFdActorDocReportDetailsController[index].ValueData = FDRIAnswer;
  }

  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }

  //
  public SaveFDActorDocReportDetails() {
    this.CurrentFDActorReportDetailsDocRequest.FdActorDocReportDetailsController = this.CurrentFdActorDocReportDetailsController;
    this.fdservice.SaveFDActorDocReportDetails(this.CurrentFDActorReportDetailsDocRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {

            alertFunctions.AlertParam('Saved Successfully.....!');


            this.stopRefreshing();
           
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");
          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


      (error) => {

        if (error == "401 - Unauthorized") {
          alertFunctions.AlertParamEr(error);

          this.stopRefreshing();



        }
        else {
          alertFunctions.AlertParamEr(error);

          this.stopRefreshing();
        }
      }
      );

  }
  //


}
